import { UntypedFormGroup } from "@angular/forms";
import { ReportClaimRequest } from "./report-claim-request";

export class ClaimFormMapper {

    public static mapCustomerForm(claimRequest: ReportClaimRequest, form: UntypedFormGroup): void {
        if (!form) return;

        const claimForm = form.value;

        claimRequest.contractNumber = claimForm.contractNumber;
        claimRequest.customerFirstName = claimForm.customerFirstName;
        claimRequest.customerLastName = claimForm.customerLastName;
        claimRequest.breakdownDate = claimForm.breakdownDate.toLocaleDateString("en-US");
        claimRequest.currentMileage = claimForm.currentMileage;
        claimRequest.vin = claimForm.vin;
    }
    
    public static mapReportClaimForm(claimRequest: ReportClaimRequest, form: UntypedFormGroup): void {
        if (!form) return;

        const claimForm = form.value;

        claimRequest.repairFacilityName = claimForm.repairFacilityName;
        claimRequest.repairFacilityBusinessEmail = claimForm.businessEmailAddress;
        claimRequest.repairFacilityContactEmail = claimForm.contactEmailAddress;
        claimRequest.repairFacilityPhone = claimForm.phoneNumber;
        claimRequest.repairFacilityContact = claimForm.repairFacilityContactName;
        claimRequest.repairFacilityPreferredContactMethod = 'Phone';
        claimRequest.repairFacilityAddressLine1 = claimForm.streetAddress1;
        claimRequest.repairFacilityAddressLine2 = claimForm.streetAddress2;
        claimRequest.repairFacilityState = claimForm.state;
        claimRequest.repairFacilityCity = claimForm.city;
        claimRequest.repairFacilityZip = claimForm.zip;

        claimRequest.repairFacilityLaborRatePerHour = claimForm.laborRatePerHour;
        claimRequest.repairFacilityLaborManualUsed = claimForm.laborManualUsed;
        claimRequest.repairFacilityPreferredPayment = claimForm.preferredPaymentMethod;
    }
    
    public static mapEstimateForm(claimRequest: ReportClaimRequest, form: UntypedFormGroup): void {
        if (!form) return;

        const claimForm = form.value;
        
        claimRequest.customerConcern = claimForm.customerConcern;
        claimRequest.causeOfFailure = claimForm.causeOfFailure;
    }
}